import { WSService } from "../../utils/WSService";

export const serviceInvitations = new WSService("/users/invitation");
